module.exports = __webpack_public_path__ + "img/scratch_select.c06c7c18.svg";